export const App = {
    namespaced: true,

    state: {
        prevRoute: {}
    },


};
